<template lang="pug">
  #app
    Header
    main.main
      transition(name="slide-fade" mode="out-in")
        router-view
    Footer
</template>
<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"

export default {
  components: {
    Header,
    Footer,
  }
}

</script>

<style lang="scss">
  // #app{
  //   background-color: black;
  // }

</style>
